import { randomNumber } from '../../../../utilities'
import { WoundCareConstants } from './woundCare.constants'
import { IWoundCareAction, IWoundCareState } from './woundCare.types'

export const initialWoundCareState: IWoundCareState = {
  actions: [],
  site: [],
  size: '',
  assessedBy: null,
  procedureComplications: [],
  response: null,
  responsePNNV: null,
  authorization: null,
  comments: '',
  addToTimeline: false,
  updateInputRows: false,
  key: randomNumber().toString(),
  date: '',
  time: '',
  successfulAttempt: true,
  pta: false,
  attempts: '1',
  type: 'Wound Care',
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  isEkgImport: null,
  nemsisCode: null,
}

export function woundCareReducer(
  state: IWoundCareState = initialWoundCareState,
  action: IWoundCareAction
): IWoundCareState {
  switch (action.type) {
    case WoundCareConstants.SET_ACTIONS:
      return { ...state, actions: action.actions }
    case WoundCareConstants.SET_SITE:
      return { ...state, site: action.site }
    case WoundCareConstants.SET_SIZE:
      return { ...state, size: action.size }
    case WoundCareConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case WoundCareConstants.SET_DATE:
      return { ...state, date: action.date }
    case WoundCareConstants.SET_TIME:
      return { ...state, time: action.time }
    case WoundCareConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case WoundCareConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case WoundCareConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case WoundCareConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case WoundCareConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case WoundCareConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case WoundCareConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case WoundCareConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case WoundCareConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case WoundCareConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case WoundCareConstants.SET_STATE:
      return { ...action.woundCareState, updateInputRows: true }
    case WoundCareConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case WoundCareConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case WoundCareConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case WoundCareConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case WoundCareConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case WoundCareConstants.RESET_STATE:
      return {
        actions: [],
        site: [],
        size: '',
        assessedBy: null,
        procedureComplications: [],
        response: null,
        responsePNNV: null,
        authorization: null,
        comments: '',
        addToTimeline: false,
        updateInputRows: true,
        key: randomNumber().toString(),
        date: '',
        time: '',
        successfulAttempt: true,
        pta: false,
        attempts: '1',
        type: 'Wound Care',
        rolePerforming: null,
        rolePerformingPNNV: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        isEkgImport: null,
        nemsisCode: null,
      }
    default:
      return state
  }
}
